<ng-template class="container" #content let-modal>
  <div id="modal-erro" class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Erro</h4>
    <button class="color-button" type="button" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span class="icon-close" aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div style="background-color: #fdf2f4;" class="alert border border-danger rounded" role="alert">
      <strong style="color: #e4002b;">{{titulo}}</strong>
      <p style="color: #333333;">{{mensagem}}</p>
    </div>

  </div>
</ng-template>
